export const LOAD_RECOMMENDATIONS_INIT = 'LOAD_RECOMMENDATIONS_INIT';
export const LOAD_RECOMMENDATIONS_SUCCESS = 'LOAD_RECOMMENDATIONS_SUCCESS';
export const LOAD_RECOMMENDATIONS_ERROR = 'LOAD_RECOMMENDATIONS_ERROR';
